<script>

	import { onMount } from 'svelte';

	import QRCode from 'qrcode';

	import { event, qr } from '../lib/stores.js';

	onMount(async () => {

		if (!$qr) {

			let url = $event.url + '/app';

			let bg = $event.theme.colors[$event.theme.app.bgColor];
			let fg = $event.theme.colors[$event.theme.app.textColor];

			$qr = await QRCode.toDataURL(url, { 
				width: 600,
				color: {
					dark: fg,
				   light: bg
				}
			});

		}

	});

</script>

<style>
	img {
		max-height: 50vh;
		max-width: 30vw;
	}
</style>

{#if $qr}
	<img src={$qr} alt="QR code"/>
{/if}